import { Download } from "lucide-react";

const EXPORTS = [
  { key: "users", label: "Users (all brokers + admins)" },
  { key: "listings", label: "Listings (with owner)" },
  { key: "transactions", label: "Transactions (billing history)" },
];

export default function AdminExportsPage() {
  const base = process.env.REACT_APP_BACKEND_URL;
  return (
    <div className="mx-auto w-full max-w-3xl px-6 py-12 md:px-10" data-testid="admin-exports-page">
      <div className="mb-rise">
        <div className="inline-flex items-center gap-1.5 rounded-full border border-brand-navy/15 bg-brand-navy/5 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-brand-navy">
          <Download className="h-3 w-3" />
          Data exports
        </div>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          CSV exports
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-gray-500">
          Excel-safe UTF-8 with BOM. All downloads are audit-logged.
        </p>
      </div>

      <ul className="mt-8 divide-y divide-gray-100 rounded-2xl border border-gray-100 bg-white shadow-mb-card">
        {EXPORTS.map((e) => (
          <li key={e.key} className="flex items-center justify-between p-5">
            <div>
              <div className="text-sm font-semibold text-gray-900">{e.label}</div>
              <div className="mt-0.5 text-xs text-gray-500">
                GET /api/admin/export/{e.key}.csv
              </div>
            </div>
            <a
              href={`${base}/api/admin/export/${e.key}.csv`}
              download
              className="mb-focus-ring inline-flex items-center gap-1.5 rounded-full bg-brand-navy px-4 py-2 text-xs font-semibold text-white hover:bg-brand-navy-hover"
              data-testid={`export-${e.key}`}
            >
              <Download className="h-3.5 w-3.5" />
              Download
            </a>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-gray-400">
        Note: the link uses your active bearer token via the browser&apos;s
        Authorization header on same-origin fetches. On some browsers the
        &lt;a download&gt; may not forward the token — if the download 401s,
        use `curl -H &quot;Authorization: Bearer &lt;token&gt;&quot;` from a terminal.
      </p>
    </div>
  );
}
